/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2, breakpoints } from '@coursera/cds-core';

type Props = {
  trackingIndex?: number;
};

// TODO: redesign-2026 -- placeholder box; the real EOI form lands in a follow-up PR.
const styles = {
  container: css`
    background: var(--cds-color-neutral-background-primary);
    border-radius: 8px;
    padding: var(--cds-spacing-200) var(--cds-spacing-300);

    ${breakpoints.up('lg')} {
      padding: var(--cds-spacing-300) var(--cds-spacing-400);
    }
  `,
  title: css`
    margin-bottom: 0;
  `,
};

const ExperimentalEoiForm = (_props: Props) => {
  return (
    <div css={styles.container} data-testid="experimental-eoi-form">
      <Typography2 component="h3" variant="titleSmall" css={styles.title}>
        Placeholder for the EOI form -- will be replaced with the real form in a follow-up PR.
      </Typography2>
    </div>
  );
};

export default ExperimentalEoiForm;
